/**
 * Ceska lokalizace datumu a casu — jedna centralni utilita pro celou app.
 * Vstup: ISO string (z backendu LocalDate/LocalDateTime) nebo Date.
 * Prazdny/null vstup -> "—".
 */

const DATE_FMT = new Intl.DateTimeFormat('cs-CZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATE_TIME_FMT = new Intl.DateTimeFormat('cs-CZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const TIME_FMT = new Intl.DateTimeFormat('cs-CZ', {
  hour: '2-digit',
  minute: '2-digit',
});

const parse = (value: string | Date | null | undefined): Date | null => {
  if (value == null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** 26.04.2026 */
export const formatDateCz = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? DATE_FMT.format(d).replace(/\s/g, '') : '—';
};

/** 26.04.2026 14:32 */
export const formatDateTimeCz = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? DATE_TIME_FMT.format(d).replace(/\s/g, ' ') : '—';
};

/** 14:32 */
export const formatTimeCz = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? TIME_FMT.format(d) : '—';
};
